interface StatusCardProps {
    label: string;
    value: string | number;
    badge?: boolean;
    badgeColor?: "purple" | "blue" | "gray";
}

export function StatusCard({
    label,
    value,
    badge,
    badgeColor,
}: StatusCardProps) {
    const colorClasses = {
        purple: "bg-purple-500/10 text-purple-400 border-purple-500/20",
        blue: "bg-blue-500/10 text-blue-400 border-blue-500/20",
        gray: "bg-slate-700/50 text-slate-300 border-slate-600",
    };

    return (
        <div className="bg-slate-800/50 rounded-lg p-3 border border-slate-700">
            <div className="text-xs text-slate-500 mb-1">{label}</div>
            {badge ? (
                <span className={`px-2 py-1 rounded text-sm font-bold uppercase border ${colorClasses[badgeColor || "gray"]}`}>
                    {value}
                </span>
            ) : (
                <div className="text-xl font-bold text-white">{value}</div>
            )}
        </div>
    );
}
